/* global lottie */
import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    // lottie-web(lottie.min.js)が読み込まれていない場合は何もしない(plugin.phpで制御/テーマ側enqueueでも制御)
    if (typeof lottie === 'undefined') return;

    // 同一ページにある全てのlottieを取得
    const players = document.querySelectorAll('.lpcb-lottie__player');
    if (!players.length) return; // なければreturn

    players.forEach((el) => {
        // 保存データを取得
        const src = el.dataset.src || '';
        if (!src) return;
        const trigger = (el.dataset.trigger || 'load');
        const loop = el.dataset.loop === '1';
        const loopCount = parseInt(el.dataset['loopCount'] || '0', 10) || 0;
        const speed = parseFloat(el.dataset.speed || '1') || 1;
        const renderer = el.dataset.renderer || 'svg';
        const pauseOffscreen = el.dataset.pauseOffscreen === '1';

        // 既存子要素（前回描画の残骸）をクリア（リピート再初期化対策）
        el.innerHTML = '';

        // ループ設定：指定回数 > 0 はイベントで手動ループするのでLottie本体のループは loop=false で生成
        const useInfiniteLoop = loop && loopCount === 0;

        // lottieアニメーションの生成
        const anim = lottie.loadAnimation({
            container: el,
            renderer: renderer,
            loop: useInfiniteLoop,
            autoplay: trigger === 'load', // ロード時開始のみ自動再生
            path: src,
        });

        // スピードセット
        anim.setSpeed(speed);

        // ===== ループ回数・終了時の扱い =====
        // remain: 残りループ回数（loop=false は 1回とみなす）
        let remain = loop ? (loopCount > 0 ? loopCount : 0) : 1;
        let finished = false; // 完走後は true（再生しない）

        // アニメーション終了時の処理
        anim.addEventListener('complete', () => {
            if (loop) {
                // ループする場合
                if (loopCount > 0) {
                    remain -= 1; // 残りループ回数を減らす
                    if (remain > 0) {
                        // 指定回数が残っている間は先頭から再生
                        anim.goToAndPlay(0, true);
                    } else {
                        // 最後は最終フレームで停止
                        finished = true;
                        anim.goToAndStop(Math.max(0, (anim.totalFrames || 1) - 1), true);
                    }
                }
                // loopCount=0(無限ループ)は complete ごとに自動継続（何もしない）
            } else {
                // 1回だけ再生（最後で止める）
                finished = true;
                anim.goToAndStop(Math.max(0, (anim.totalFrames || 1) - 1), true);
            }
        });

        // 開始トリガー制御
        if (trigger === 'scroll') {
            // 見えたら再生、見えなくなったら(省電力ON時のみ)一時停止
            const io = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    // 完走していない限り、見えたら再生
                    if (!finished) anim.play();
                } else {
                    if (!finished && pauseOffscreen) anim.pause();
                }
            }, { threshold: 0.15 });
            io.observe(el);

        } else if (trigger === 'hover') {
            // === デバイス判定：モバイル/タッチ系か（機能検出ベース） ===
            const isTouchLike =
                (window.matchMedia && (
                    window.matchMedia('(hover: none)').matches ||
                    window.matchMedia('(pointer: coarse)').matches ||
                    window.matchMedia('(any-hover: none)').matches ||
                    window.matchMedia('(any-pointer: coarse)').matches
                )) ||
                (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0);
        
            // PC環境
            if (!isTouchLike) {
                el.addEventListener('mouseenter', () => {
                    if (!finished) anim.play();
                }, { passive: true });
                el.addEventListener('mouseleave', () => {
                    if (!finished) anim.pause();
                }, { passive: true });

            // モバイル(タップで再生)
            } else {
                let userPlaying = false; // 再生中かどうか
        
                const toggle = () => {
                    if (finished) return;
                    if (anim.isPaused) {
                        anim.play();
                        userPlaying = true;
                    } else {
                        anim.pause();
                        userPlaying = false;
                    }
                };

                // タップ後に click が発火
                el.addEventListener('click', toggle, false);
 
                // 画面外監視：外れたら一時停止、戻ったら「再生中の場合は」再開
                const ioHoverMobile = new IntersectionObserver(([entry]) => {
                    if (finished) return;
                    if (entry.isIntersecting) {
                        if (userPlaying) anim.play();
                    } else {
                        anim.pause();
                    }
                }, { threshold: 0.15 });
                ioHoverMobile.observe(el);
            }

        } else if (trigger === 'click') {
            // 1回だけ開始クリック → 以後はスクロールの可視/不可視で自動制御
            let started = false;

            const handleClick = () => {
                if (started || finished) return;
                started = true;
                anim.goToAndPlay(0, true);
                // 開始後はクリック無効化（“開始は1回だけ”）
                el.removeEventListener('click', handleClick, false);
            };
            el.addEventListener('click', handleClick, false);

            // クリック開始後は、画面外で一時停止 / 画面に戻ったらその位置から再開
            const ioClick = new IntersectionObserver(([entry]) => {
                if (!started || finished) return;
                if (entry.isIntersecting) {
                    anim.play();  // その位置から再開
                } else {
                    anim.pause(); // 画面外では停止
                }
            }, { threshold: 0.15 });
            ioClick.observe(el);

        } else if (trigger === 'load') {
            // 自動再生は loadAnimation の autoplay:true で開始済み
            if (pauseOffscreen) {
                const io = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        if (!finished) anim.play();
                    } else {
                        anim.pause();
                    }
                }, { threshold: 0.0 });
                io.observe(el);
            }
        }

    });
});
